import { Preferences } from '@capacitor/preferences'
import { Box, Typography } from '@mui/material'
import { useSignal, useSignalEffect } from '@preact/signals-react'
import { NavigationView } from '../../layout/NavigationView'

export const StorePage = () => {
    const prefs = useSignal<any>(null)

    useSignalEffect(() => {
        getAllPreferences().then((p) => {
            prefs.value = p
        })
    })

    const getAllLocalStorage = () => {
        const arg = {}
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i)
            arg[key] = localStorage.getItem(key)
        }
        return arg
    }
    const getAllPreferences = async () => {
        const arg = {}
        const keys = await Preferences.keys()
        for (let i = 0; i < keys.keys.length; i++) {
            const key = keys.keys[i]
            arg[key] = await Preferences.get({ key })
        }
        return arg
    }
    return (
        <Box paddingTop={'10px'}>
            <NavigationView
                navigationBarTitle="Store Settings"
                navigationBarSubtitle="local storage and preferences"
                backButtonAction={() => {
                    window.goBack()
                }}
                usePageTransition
            >
                <Box sx={{ overflowX: 'auto' }}>
                    <Typography>LocalStorage</Typography>
                    <pre>{JSON.stringify(getAllLocalStorage(), null, 2)}</pre>
                    <Typography>Prefences</Typography>
                    <pre>{JSON.stringify(prefs.value, null, 2)}</pre>
                </Box>
            </NavigationView>
        </Box>
    )
}
